import { createAppTestIds } from './index';

/**
 * Test IDs for Zoom integration
 */
export const ZOOM_TEST_IDS = {
  ...createAppTestIds('zoom'),
} as const;
